// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"SubscriptionBillingDisclaimer_disclaimer__zy4PF"};